var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#EAFAF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 21C14 19.375 15.3125 18 17 18H23C24.625 18 26 19.375 26 21V22H38V21C38 19.375 39.3125 18 41 18H47C48.625 18 50 19.375 50 21V27C50 28.6875 48.625 30 47 30H41C39.3125 30 38 28.6875 38 27V26H26V27C26 27.125 25.9375 27.25 25.9375 27.3125L31 34H37C38.625 34 40 35.375 40 37V43C40 44.6875 38.625 46 37 46H31C29.3125 46 28 44.6875 28 43V37C28 36.9375 28 36.8125 28 36.6875L23 30H17C15.3125 30 14 28.6875 14 27V21Z",
    fill: "#2FB273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/diagram.cacbeb728b6e385cbd92588394aedfb3.svg";
export { ForwardRef as ReactComponent };